
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M13.333 8A5.333 5.333 0 112.666 8a5.333 5.333 0 0110.667 0zm1.334 0A6.667 6.667 0 111.333 8a6.667 6.667 0 0113.334 0zm-6-3.333a.667.667 0 10-1.334 0V8c0 .21.1.407.267.533l2.667 2a.666.666 0 10.8-1.066l-2.4-1.8v-3z","clip-rule":"evenodd"}})])
          )
        }
      }
    